import { createFileRoute } from "@tanstack/react-router";
import { validateGameSearch } from "@/features/game/gameSearch";

export const Route = createFileRoute("/play")({
  validateSearch: validateGameSearch,
});
